export default __webpack_public_path__ + "static/media/newDeleteIcon.bd08aa86.svg";